<div>

    <div class="row grid-header">
        <div class="col-6">
            <h3 style="color: #323232" *ngIf="!isSearchGrid" i18n>Products ({{totalCount}})</h3>
            <h3 style="color: #323232" *ngIf="isSearchGrid" i18n>Search results ({{totalCount}})</h3>
        </div>
        <div class="col-6 text-right">
            <div>
                <label i18n> Sort By</label> &nbsp;
                <mat-select (selectionChange)="sortChanged()" [(ngModel)]="sortBy" style="width: 150px;
    background-color: white;
    padding: 7px;
    margin-left: 10px;
}">
                    <mat-option value="newest" i18n="@@newestfirst">
                        Newest first
                    </mat-option>
                    <mat-option value="lowest_price" i18n="@@lowestprice">
                        Price - Low to High
                    </mat-option>

                    <mat-option value="highest_price" i18n="@@highestprice">
                        Price - High to Low
                    </mat-option>
                </mat-select>

            </div>

        </div>
    </div>


    <div *ngIf="products.length==0 && isLoading" class="row container-fluid mb-4">

        <div class="col-md-3 col-sm-12 text-left">
            <app-product-block-shimmer></app-product-block-shimmer>
        </div>
        <div class="col-md-3 col-sm-12 text-left">
            <app-product-block-shimmer></app-product-block-shimmer>
        </div>
        <div class="col-md-3 col-sm-12 text-left">
            <app-product-block-shimmer></app-product-block-shimmer>
        </div>
        <div class="col-md-3 col-sm-12 text-left">
            <app-product-block-shimmer></app-product-block-shimmer>
        </div>

    </div>

    <div *ngIf="products.length==0 && !isLoading" class="row container-fluid mb-4">
        <div class="alert alert-info" i18n>No results found</div>
    </div>

    <div class="  alert-info p-2 grid-header" *ngIf="isSearchGrid" style="    font-size: 15px;
    padding-left: 0;">
        <table>
            <tr>
                <td><label i18n="@@show_results_for">Showing result for searching keyword:</label> <label
                        style="font-weight: bold">"{{this.searchKeyword}}" &nbsp; </label></td>
                <td>{{products.length}} <label i18n="@@out_of">out of</label> {{this.totalCount}}</td>
            </tr>
        </table>

    </div>
    <div class="grid-header">

    </div>

    <div class="row">
<!--        <div class="col-md-3">-->
<!--            <app-product-filter-type-category [categories]="filter_categories"></app-product-filter-type-category>-->
<!--        </div>-->
        <div class="col-md-12">
            <div class="row">
                <!--        <div class="col-lg-3" *cdkVirtualFor="let product of Products">-->
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngFor="let p of products">

                    <app-product-block [item]="p"></app-product-block>
                </div>

                <div class="alert alert-info container-fluid text-center" *ngIf="products.length == 0 && !isLoading">
                    There are currently no products for this selection.
                </div>

                <div *ngIf="!isButtonHidden()" class="text-center container-fluid">
                    <div *ngIf="isLoading && products.length != totalCount"
                         class="text-center container-fluid pt-1 pb-3">
                        <img src="assets/loader.gif" width="40"><label i18n="@@loading_products">Loading
                        products</label>
                    </div>
                    <div *ngIf="!isLoading" class="text-center container-fluid pt-1 pb-3">
                        <button class="btn btn-primary btn-success" (click)="getNextPage($event)" i18n="@@loadMoreProducts">Load more
                            products
                        </button>
                    </div>
                </div>

                <div class="text-center container-fluid pt-1 pb-3">
                    <button #load_more_btn class="btn btn-primary btn-success" style="visibility: hidden;" i18n>Load
                        more products
                    </button>
                </div>
            </div>
        </div>
    </div>

</div>
<!--</cdk-virtual-scroll-viewport>-->

